export const checkinVersions = ['V2', 'V3'] as const
export type CheckinVersion = (typeof checkinVersions)[number]

export const checkinVersionLabel: Record<CheckinVersion, string> = {
  V2: 'V2 (250)',
  V3: 'V3 (300)',
}
